import { DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material"
import { BroadcastInfo, BroadcastText, StyledWalletDialog, actionIson } from "./MenuStyle"
import Input from "../../Modules/FlowBuilder/Components/Input"
import AppButton from "../../AppComponents/AppButton"
import CloseIcon from '@mui/icons-material/Close';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useState } from "react";
import { ProtectedAppButton } from "../../AppComponents/ProtectedComponents";

const AddWallet = (prpos: any): JSX.Element => {
    const [balance, setBalance] = useState<any>("")
    const [error, setError] = useState("");
    return (
        <StyledWalletDialog
            open={prpos.check}
            onClose={() => prpos.setCheck(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className="walletHeader" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Add credits to your wallet
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => { prpos.setCheck(false) }}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogTitle className="walletTitle" sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Enter the Amount you want to add balance to Wallet
                <div className="walletInput"> <Input
                    placeholder="Enter Your Amount"
                    value={balance}
                    isVariableMenu={false}
                    onChange={(e: any) => {
                        const value = e.target.value.trim();

                        if (/^\d*\.?\d*$/.test(value)) {
                            setBalance(value);

                            if (!value) {
                                setError("Please enter amount");
                            } else if (Number(value) <= 0) {
                                setError("Amount must be greater than 0");
                            } else {
                                setError("");
                            }
                        } else {
                            setError("Only numbers are allowed");
                        }
                    }}
                />
                    {error && (
                        <p style={{ color: "red", fontSize: "10px", marginTop: "2px" }}>
                            {error}
                        </p>
                    )}
                </div>
                <div className="walletValues">
                    <AppButton
                        variant="grey"
                        className="walletValue"
                        onClick={() => setBalance(100)}
                    >
                        ₹ 100
                    </AppButton>
                    <AppButton
                        variant="grey"
                        className="walletValue"
                        onClick={() => setBalance(500)}
                    >
                        ₹ 500
                    </AppButton>
                    <AppButton
                        variant="grey"
                        className="walletValue"
                        onClick={() => setBalance(1000)}
                    >
                        ₹ 1000
                    </AppButton>
                    <AppButton
                        variant="grey"
                        className="walletValue"
                        onClick={() => setBalance(2000)}
                    >
                        ₹ 2000
                    </AppButton></div>
                <BroadcastText>
                    Term And Conditions
                </BroadcastText>
                <div className="walletCondition">
                    <BroadcastInfo>
                        <FiberManualRecordIcon style={actionIson} /> Subscription charges are not deducted from wallet balance
                    </BroadcastInfo>
                    <BroadcastInfo >
                        <FiberManualRecordIcon style={actionIson} /> Wallet balance is non-refundable & non-transferable
                    </BroadcastInfo>
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">

                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <ProtectedAppButton
                    moduleId="add_credits_to_wallet"
                    onClick={() => {
                        if (!balance) {
                            setError("Please enter amount");
                            return;
                        }
                        if (Number(balance) <= 0) {
                            setError("Amount must be greater than 0");
                            return;
                        }

                        prpos.addBalance(balance);
                    }}
                    disabled={Number(balance) <= 0 || isNaN(Number(balance))}
                    style={{ margin: "10px 8px" }}
                >
                    Add Balance
                </ProtectedAppButton>
            </DialogActions>
        </StyledWalletDialog>
    )
}
export default AddWallet